import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilClipboard,
  cilCommentBubble,
  cilFax,
  cilFeaturedPlaylist,
  cilIndustry,
  cilRowing,
  cilSpeedometer,
  cilUser,
} from "@coreui/icons";
import { cilAddressBook, cilCast } from "@coreui/icons";

import { CNavItem } from "@coreui/react";
import ROUTE_NAMES from "../routes/routeNames";

/**
 * @description NAVLINKS CONTENTS FOR SIDEBAR
 */

const navLinks = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/dashboard",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Users",
    to: "/users",
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Content Management",
    to: "/content-management",
    icon: <CIcon icon={cilFax} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Sites",
    to: "/sites",
    icon: <CIcon icon={cilRowing} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Cities",
    to: "/cities",
    icon: <CIcon icon={cilIndustry} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Report Management",
    to: "/report-management",
    icon: <CIcon icon={cilClipboard} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Feedback",
    to: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK,
    icon: <CIcon icon={cilFeaturedPlaylist} customClassName={"nav-icon"} />,
  },
  {
    component: CNavItem,
    name: "Queries",
    to: ROUTE_NAMES.MAIN_ROUTES.QUERIES,
    icon: <CIcon icon={cilCommentBubble} customClassName={"nav-icon"} />,
  },
];
export default navLinks;

export const modes = [
  { id: 1, value: "User", icon: cilAddressBook },
  { id: 2, value: "Post", icon: cilCast },
];
